import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services';
import { MatTableDataSource } from '@angular/material/table';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { DDFSQuoteResponse, ApiResponse, DDFSQuoteTermResponse, DDFSQuoteTermLine } from '../../models/api-response.model';
import { DDFSQuoteLineModel, DDFSQuoteModel } from '../../models/shopping-cart.model';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-finance-details',
  templateUrl: './finance-details.component.html',
  styleUrls: ['./finance-details.component.css']
})
export class FinanceDetailsComponent implements OnInit, OnDestroy {

  title = 'Finance Details';
  cartId: string;
  cartName: string;
  financeType: string;
  displayedColumns: string[];
  displayedColumnsAdditional: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE', 'ADDBUTTON', 'DELETEBUTTON'];
  displayedColumnsPass: string[] = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE', 'ADDBUTTON', 'DELETEBUTTON'];
  dataSourceItems = new MatTableDataSource();
  dataSourceAdditionalCharge = new MatTableDataSource();
  dataSourcePastThrough = new MatTableDataSource();
  quote: DDFSQuoteModel;
  accountNumber = '';
  accountName = '';
  bsb = '';
  loadContent = false;
  totalPrice: number;
  additionalChargeTotalPrice: number;
  passThroughChargeTotalPrice: number;
  ddfsQuoteId: number;
  selectedTerm: DDFSQuoteTermLine;
  shoppingCartItems: DDFSQuoteLineModel[] = [];
  additionalCharges: DDFSQuoteLineModel[] = [];
  passThroughCharges: DDFSQuoteLineModel[] = [];
  terms: DDFSQuoteTermLine[] = [];
  termsMessage: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private commonService: CommonService,
    private shoppingCartService: ShoppingCartService
  ) {

  }

  ngOnInit() {
    if (this.activeRouter.parent.parent) {
      this.activeRouter.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(query => {
        this.loadContent = false;
        this.financeType = query.get('type').toLowerCase();
        if (this.financeType === 'enduser') {
          this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE', 'SELLINGPRICE', 'SELLINGLINEPRICE'];
        } else {
          this.displayedColumns = ['SKU', 'DESCRIPTION', 'QTY', 'UNITPRICE', 'LINEPRICE'];
        }
        this.activeRouter.parent.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
          if (res) {
            this.cartId = res.get('id');
            this.cartName = res.get('cartName');
            this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, true).pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: DDFSQuoteResponse) => {
              this.totalPrice = 0;
              this.additionalChargeTotalPrice = 0;
              this.passThroughChargeTotalPrice = 0;
              if (result) {
                this.quote = result.quote;
                this.accountNumber = this.quote.accountNumber === '0' ? '' : this.quote.accountNumber;
                this.accountName = this.quote.accountName;
                this.bsb = this.quote.bsb;
                this.shoppingCartService.GetFinanceQuoteTermAmount(result).pipe(takeUntil(this.ngUnsubscribe)).subscribe((termRes: DDFSQuoteTermResponse) => {
                  this.loadContent = true;
                  this.shoppingCartItems = result.items;
                  this.ddfsQuoteId = this.shoppingCartItems[0].ddfsQuoteId;
                  this.additionalCharges = result.additionalChanrges;
                  this.passThroughCharges = result.passThroughChanrges;
                  if (this.additionalCharges && this.additionalCharges.length) {
                    this.additionalCharges[0].rowId = 1;
                    this.additionalCharges.filter(ac => ac.id !== this.additionalCharges[0].id).forEach(add => {
                      add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
                    });
                    this.additionalCharges.forEach(ac => {
                      this.additionalChargeTotalPrice += ac.lineSellPrice;
                    });
                    this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
                  }
                  // else {
                  //   let additionalChargeModel = {
                  //     id: 0,
                  //     rowId: this.additionalCharges[this.additionalCharges.length - 1].rowId + 1,
                  //     ddfsQuoteId: this.ddfsQuoteId,
                  //     sku: "",
                  //     description: "",
                  //     quantity: 0,
                  //     unitPrice: 0,
                  //     sellPrice: 0,
                  //     lineSellPrice: 0,
                  //     linePrice: 0,
                  //   } as DDFSQuoteLineModel
                  //   this.loadContent = false;
                  //   this.shoppingCartService.SaveFinanceAdditionalChange(additionalChargeModel).subscribe((res: ApiResponse) => {
                  //     if (res && res.status) {
                  //       this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, true).subscribe((result: DDFSQuoteResponse) => {
                  //         this.loadContent = true;
                  //         this.additionalCharges = result.additionalChanrges;
                  //         this.additionalChargeTotalPrice = 0;
                  //         if (this.additionalCharges) {
                  //           this.additionalCharges[0].rowId = 1;
                  //           this.additionalCharges.filter(ac => ac.id != this.additionalCharges[0].id).forEach(add => {
                  //             add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
                  //           });
                  //           this.additionalCharges.forEach(ac => {
                  //             this.additionalChargeTotalPrice += ac.lineSellPrice;
                  //           });
                  //           this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
                  //         }
                  //       },
                  //         (error: any) => {
                  //           console.info(error);
                  //           this.loadContent = true;
                  //         });
                  //     } else {
                  //       this.loadContent = true;
                  //       this.commonService.showError(".addadditionalcharge"+additionalChargeModel.rowId, res.responseMessage, "right");
                  //     }
                  //   },
                  //     (error: any) => {
                  //       console.info(error);
                  //       this.loadContent = true;
                  //     });
                  // }
                  if (this.passThroughCharges && this.passThroughCharges.length) {
                    this.passThroughCharges[0].rowId = 1;
                    this.passThroughCharges.filter(ac => ac.id !== this.passThroughCharges[0].id).forEach(add => {
                      add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
                    });
                    this.passThroughCharges.forEach(ac => {
                      this.passThroughChargeTotalPrice += ac.lineSellPrice;
                    });
                    this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
                  }
                  // else {
                  //   let passThroughChargeModel = {
                  //     id: 0,
                  //     rowId: this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1,
                  //     ddfsQuoteId: this.ddfsQuoteId,
                  //     sku: "",
                  //     description: "",
                  //     quantity: 0,
                  //     unitPrice: 0,
                  //     sellPrice: 0,
                  //     lineSellPrice: 0,
                  //     linePrice: 0,
                  //   } as DDFSQuoteLineModel
                  //   this.loadContent = false;
                  //   this.shoppingCartService.SavePastThroughCharge(passThroughChargeModel).subscribe((res: ApiResponse) => {
                  //     if (res && res.status) {
                  //       this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, true).subscribe((result: DDFSQuoteResponse) => {
                  //         this.loadContent = true;
                  //         this.passThroughCharges = result.passThroughChanrges;
                  //         this.passThroughChargeTotalPrice = 0;
                  //         if (this.passThroughCharges) {
                  //           this.passThroughCharges[0].rowId = 1;
                  //           this.passThroughCharges.filter(ac => ac.id != this.passThroughCharges[0].id).forEach(add => {
                  //             add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
                  //           });
                  //           this.passThroughCharges.forEach(ac => {
                  //             this.passThroughChargeTotalPrice += ac.lineSellPrice;
                  //           });
                  //           this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
                  //         }
                  //       },
                  //         (error: any) => {
                  //           console.info(error);
                  //           this.loadContent = true;
                  //         });
                  //     } else {
                  //       this.loadContent = true;
                  //       this.commonService.showError(".addpasscharge"+passThroughChargeModel.rowId, res.responseMessage, "right");
                  //     }
                  //   },
                  //     (error: any) => {
                  //       console.info(error);
                  //       this.loadContent = true;
                  //     });
                  // }
                  this.shoppingCartItems.forEach(item => {
                    item.linePrice = item.unitPrice * item.quantity;
                    if (this.financeType === 'enduser') {
                      this.totalPrice += item.lineSellPrice;
                    } else {
                      this.totalPrice += item.linePrice;
                    }
                  });
                  this.dataSourceItems = new MatTableDataSource(this.shoppingCartItems);
                  if (termRes && termRes.terms && termRes.terms.length > 0) {
                    this.terms = termRes.terms;
                    if (this.quote.termInMonths) {
                      this.selectedTerm = this.terms.filter(ter => ter.termId === this.quote.termInMonths)[0];
                    } else {
                      this.selectedTerm = this.terms.filter(ter => ter.termId === 24)[0];
                      this.selectTerm(this.selectedTerm);
                    }
                  } else {
                    this.termsMessage = termRes.responseMessage;
                  }
                },
                  (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                  });
              } else {
                this.loadContent = true;
              }
            },
              (error: any) => {
                console.error(error);
                this.loadContent = true;
              });
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }

  addNewRow(): void {
    const additionalChargeModel = {
      id: 0,
      rowId: this.additionalCharges.length ? this.additionalCharges[this.additionalCharges.length - 1].rowId + 1 : 1,
      ddfsQuoteId: this.ddfsQuoteId,
      sku: '',
      description: '',
      quantity: 0,
      unitPrice: 0,
      sellPrice: 0,
      lineSellPrice: 0,
      linePrice: 0,
    } as DDFSQuoteLineModel;
    this.loadContent = false;
    this.shoppingCartService.SaveFinanceAdditionalChange(additionalChargeModel).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
          this.loadContent = true;
          this.additionalCharges = result.additionalChanrges;
          this.additionalChargeTotalPrice = 0;
          if (this.additionalCharges) {
            this.additionalCharges[0].rowId = 1;
            this.additionalCharges.filter(ac => ac.id !== this.additionalCharges[0].id).forEach(add => {
              add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
            });
            this.additionalCharges.forEach(ac => {
              this.additionalChargeTotalPrice += ac.lineSellPrice;
            });
            this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      } else {
        this.loadContent = true;
        this.commonService.showError('.addadditonalbtn', res.responseMessage, 'right');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  addPassThroughNewRow(): void {
    const passThroughChargeModel = {
      id: 0,
      rowId: this.passThroughCharges.length ? this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1 : 1,
      ddfsQuoteId: this.ddfsQuoteId,
      sku: '',
      description: '',
      quantity: 0,
      unitPrice: 0,
      sellPrice: 0,
      lineSellPrice: 0,
      linePrice: 0,
    } as DDFSQuoteLineModel;
    this.loadContent = false;
    this.shoppingCartService.SavePastThroughCharge(passThroughChargeModel).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
          this.loadContent = true;
          this.passThroughCharges = result.passThroughChanrges;
          this.passThroughChargeTotalPrice = 0;
          if (this.passThroughCharges) {
            this.passThroughCharges[0].rowId = 1;
            this.passThroughCharges.filter(ac => ac.id !== this.passThroughCharges[0].id).forEach(add => {
              add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
            });
            this.passThroughCharges.forEach(ac => {
              this.passThroughChargeTotalPrice += ac.lineSellPrice;
            });
            this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      } else {
        this.loadContent = true;
        this.commonService.showError('.passthroughbtn', res.responseMessage, 'right');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  saveAdditionalChargeChange(element: DDFSQuoteLineModel, className: string): void {
    // if(element.description){
      if (!element.quantity) {
        element.quantity = 1;
      }
      if (!element.sellPrice) {
        element.sellPrice = 1;
      }
      element.lineSellPrice = this.commonService.toNumber((element.quantity * element.sellPrice).toFixed(2));
      this.shoppingCartService.SaveFinanceAdditionalChange(element).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.additionalChargeTotalPrice = 0;
          if (this.additionalCharges) {
            this.additionalCharges[0].rowId = 1;
            this.additionalCharges.filter(ac => ac.id !== this.additionalCharges[0].id).forEach(add => {
              add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
            });
            this.additionalCharges.forEach(ac => {
              this.additionalChargeTotalPrice += ac.lineSellPrice;
            });
            this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
          }
          this.getTerms();
        } else {
          this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
            this.commonService.showError('.' + className, res.responseMessage, 'right');
            this.additionalCharges = result.additionalChanrges;
            this.additionalChargeTotalPrice = 0;
            if (this.additionalCharges) {
              this.additionalCharges[0].rowId = 1;
              this.additionalCharges.filter(ac => ac.id !== this.additionalCharges[0].id).forEach(add => {
                add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
              });
              this.additionalCharges.forEach(ac => {
                this.additionalChargeTotalPrice += ac.lineSellPrice;
              });
              this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
            }
            this.getTerms();
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    // }else{
    //   this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
    //     this.additionalCharges = result.additionalChanrges;
    //     if (this.additionalCharges) {
    //       element.description = this.additionalCharges.filter(ac => ac.id == element.id)[0].description
    //     }
    //     this.commonService.showError(".desaddition" + element.rowId, "Description can not be empty", "right");
    //   },
    //     (error: any) => {
    //       console.info(error);
    //       this.loadContent = true;
    //     });
    // }
  }

  savePastThroughCharge(element: DDFSQuoteLineModel, className: string): void {
    // if(element.description){
      if (!element.quantity) {
        element.quantity = 1;
      }
      if (!element.sellPrice) {
        element.sellPrice = 1;
      }
      element.lineSellPrice = this.commonService.toNumber((element.quantity * element.sellPrice).toFixed(2));
      this.shoppingCartService.SavePastThroughCharge(element).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.passThroughChargeTotalPrice = 0;
          if (this.passThroughCharges) {
            this.passThroughCharges[0].rowId = 1;
            this.passThroughCharges.filter(ac => ac.id !== this.passThroughCharges[0].id).forEach(add => {
              add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
            });
            this.passThroughCharges.forEach(ac => {
              this.passThroughChargeTotalPrice += ac.lineSellPrice;
            });
            this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
          }
          this.getTerms();
        } else {
          this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
            this.commonService.showError('.' + className, res.responseMessage, 'right');
            this.passThroughCharges = result.passThroughChanrges;
            this.passThroughChargeTotalPrice = 0;
            if (this.passThroughCharges) {
              this.passThroughCharges[0].rowId = 1;
              this.passThroughCharges.filter(ac => ac.id !== this.passThroughCharges[0].id).forEach(add => {
                add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
              });
              this.passThroughCharges.forEach(ac => {
                this.passThroughChargeTotalPrice += ac.lineSellPrice;
              });
              this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
            }
            this.getTerms();
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    // }else{
    //   this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
    //     this.passThroughCharges = result.passThroughChanrges;
    //     if (this.passThroughCharges) {
    //       element.description = this.passThroughCharges.filter(ac => ac.id == element.id)[0].description
    //     }
    //     this.commonService.showError(".despass" + element.rowId, "Description can not be empty", "right");
    //   },
    //     (error: any) => {
    //       console.info(error);
    //       this.loadContent = true;
    //     });
    // }
  }

  deleteAdditionalChargeItem(element: DDFSQuoteLineModel): void {
    if (this.additionalCharges.length > 0) {
      this.loadContent = false;
      this.shoppingCartService.DeleteFinanceAdditionalChange(element).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.getTerms();
          this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
            this.loadContent = true;
            this.additionalCharges = result.additionalChanrges;
            if (this.additionalCharges.length) {
              this.additionalCharges[0].rowId = 1;
              this.additionalCharges.filter(ac => ac.id !== this.additionalCharges[0].id).forEach(add => {
                add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
              });
            }
            this.additionalChargeTotalPrice = 0;
            if (this.additionalCharges) {
              this.additionalCharges.forEach(ac => {
                this.additionalChargeTotalPrice += ac.lineSellPrice;
              });
            }
            this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        } else {
          this.loadContent = true;
          this.commonService.showError('.additionaldelete' + element.rowId, res.responseMessage, 'right');
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
    // else if (this.additionalCharges.length == 1) {
    //   element.sku = "";
    //   element.description = "";
    //   element.quantity = 0;
    //   element.sellPrice = 0;
    //   element.lineSellPrice = 0;
    //   this.loadContent = false;
    //   this.shoppingCartService.SaveFinanceAdditionalChange(element).subscribe((res: ApiResponse) => {
    //     if (res && res.status) {
    //       this.getTerms();
    //       this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
    //         this.loadContent = true;
    //         this.additionalCharges = result.additionalChanrges;
    //         this.additionalCharges[0].rowId = 1;
    //         this.additionalChargeTotalPrice = 0;
    //         this.additionalCharges.filter(ac => ac.id != this.additionalCharges[0].id).forEach(add => {
    //           add.rowId = this.additionalCharges[this.additionalCharges.length - 1].rowId + 1;
    //         });
    //         if (this.additionalCharges) {
    //           this.additionalCharges.forEach(ac => {
    //             this.additionalChargeTotalPrice += ac.lineSellPrice;
    //           });
    //         }
    //         this.dataSourceAdditionalCharge = new MatTableDataSource(this.additionalCharges);
    //       },
    //         (error: any) => {
    //           console.info(error);
    //           this.loadContent = true;
    //         });
    //     } else {
    //       this.loadContent = true;
    //       this.commonService.showError(".additionaldelete" + element.rowId, res.responseMessage, "right");
    //     }
    //   },
    //     (error: any) => {
    //       console.info(error);
    //       this.loadContent = true;
    //     });
    // }
    // else {
    //   this.loadContent = true;
    //   this.commonService.showError(".additionaldelete" + element.rowId, "Additional Charge Table can not be empty", "left");
    // }
  }

  deletePassThroughChargeItem(element: DDFSQuoteLineModel): void {
    if (this.passThroughCharges.length > 0) {
      this.loadContent = false;
      this.shoppingCartService.DeleteFinancePassThroughChange(element).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.getTerms();
          this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
            this.loadContent = true;
            this.passThroughCharges = result.passThroughChanrges;
            if (this.passThroughCharges.length) {
              this.passThroughCharges[0].rowId = 1;
              this.passThroughCharges.filter(ac => ac.id !== this.passThroughCharges[0].id).forEach(add => {
                add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
              });
            }
            this.passThroughChargeTotalPrice = 0;
            if (this.passThroughCharges) {
              this.passThroughCharges.forEach(ac => {
                this.passThroughChargeTotalPrice += ac.lineSellPrice;
              });
            }
            this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
          },
            (error: any) => {
              console.error(error);
              this.loadContent = true;
            });
        } else {
          this.loadContent = true;
          this.commonService.showError('.passdelete' + element.rowId, res.responseMessage, 'right');
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
    // else if (this.passThroughCharges.length == 1) {
    //   element.sku = "";
    //   element.description = "";
    //   element.quantity = 0;
    //   element.sellPrice = 0;
    //   element.lineSellPrice = 0;
    //   this.loadContent = false;
    //   this.shoppingCartService.SavePastThroughCharge(element).subscribe((res: ApiResponse) => {
    //     if (res && res.status) {
    //       this.getTerms();
    //       this.shoppingCartService.GetFinanceQuoteByCartId(toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
    //         this.loadContent = true;
    //         this.passThroughCharges = result.passThroughChanrges;
    //         this.passThroughCharges[0].rowId = 1;
    //         this.passThroughChargeTotalPrice = 0;
    //         this.passThroughCharges.filter(ac => ac.id != this.passThroughCharges[0].id).forEach(add => {
    //           add.rowId = this.passThroughCharges[this.passThroughCharges.length - 1].rowId + 1;
    //         });
    //         if (this.passThroughCharges) {
    //           this.passThroughCharges.forEach(ac => {
    //             this.passThroughChargeTotalPrice += ac.lineSellPrice;
    //           });
    //         }
    //         this.dataSourcePastThrough = new MatTableDataSource(this.passThroughCharges);
    //       },
    //         (error: any) => {
    //           console.info(error);
    //           this.loadContent = true;
    //         });
    //     } else {
    //       this.loadContent = true;
    //       this.commonService.showError(".passdelete" + element.rowId, res.responseMessage, "right");
    //     }
    //   },
    //     (error: any) => {
    //       console.info(error);
    //       this.loadContent = true;
    //     });
    // } else {
    //   this.loadContent = true;
    //   this.commonService.showError(".passdelete" + element.rowId, "Pass Through Charge Table can not be empty", "left");
    // }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  saveShoppingItemChange(element: DDFSQuoteLineModel): void {
    if (!element.quantity) {
      element.quantity = 1;
      element.linePrice = element.unitPrice;
      element.lineSellPrice = element.sellPrice;
      this.commonService.showError('.qty' + element.id, 'minimum qty is 1', 'right');
    }
    element.linePrice = element.quantity * element.unitPrice;
    element.lineSellPrice = element.quantity * element.sellPrice;
    this.shoppingCartService.SaveFinanceShoppingCartChange(element).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.getTerms();
        this.totalPrice = 0;
        this.shoppingCartItems.forEach(item => {
          item.linePrice = item.unitPrice * item.quantity;
          item.lineSellPrice = item.sellPrice * item.quantity;
          if (this.financeType === 'enduser') {
            this.totalPrice += item.lineSellPrice;
          } else {
            this.totalPrice += item.linePrice;
          }
        });
        this.dataSourceItems = new MatTableDataSource(this.shoppingCartItems);
      } else {
        this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((result: DDFSQuoteResponse) => {
          this.loadContent = true;
          this.shoppingCartItems = result.items;
          this.totalPrice = 0;
          this.shoppingCartItems.forEach(item => {
            item.linePrice = item.unitPrice * item.quantity;
            if (this.financeType === 'enduser') {
              this.totalPrice += item.lineSellPrice;
            } else {
              this.totalPrice += item.linePrice;
            }
          });
          this.dataSourceItems = new MatTableDataSource(this.shoppingCartItems);
          this.commonService.showError('.qty' + element.id, 'quantity update failed', 'right');
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  getTerms(): void {
    this.loadContent = false;
    this.shoppingCartService.GetFinanceQuoteByCartId(this.commonService.toNumber(this.cartId), this.financeType, false).subscribe((res: DDFSQuoteResponse) => {
      this.shoppingCartService.GetFinanceQuoteTermAmount(res).subscribe((termRes: DDFSQuoteTermResponse) => {
        this.loadContent = true;
        if (termRes && termRes.terms) {
          this.terms = termRes.terms;
          if (this.quote.termInMonths) {
            this.selectedTerm = this.terms.filter(ter => ter.termId === this.quote.termInMonths)[0];
          } else {
            this.selectedTerm = this.terms[0];
          }
        } else {
          this.termsMessage = termRes.responseMessage;
          this.terms = [];
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  saveQuoteDetail(): void {
    this.loadContent = false;
    this.quote.accountNumber = this.accountNumber;
    this.quote.accountName = this.accountName;
    this.quote.bsb = this.bsb;
    this.quote.financeType = this.financeType === 'me' ? 1 : 2;
    this.shoppingCartService.SaveQuoteDetail(this.quote).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.getTerms();
      } else {
        this.loadContent = true;
        this.commonService.showError('.bsbinput', res.responseMessage, 'right');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  selectTerm(selectedTerm: DDFSQuoteTermLine): void {
    this.loadContent = false;
    this.selectedTerm = selectedTerm;
    this.quote.termAmount = selectedTerm.amount;
    this.quote.termInMonths = selectedTerm.termId;
    this.shoppingCartService.SaveQuoteDetail(this.quote).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.getTerms();
      } else {
        this.loadContent = true;
        this.commonService.showError('.term' + selectedTerm.termId, res.responseMessage, 'right');
      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  confirmFinancialDetails(): void {
    this.router.navigate(['financesummary'], { relativeTo: this.activeRouter });
  }

  close(): void {
    if (this.cartId) {
      this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName);
    } else {
      this.router.navigateByUrl('/home');
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
